import { kindOf } from '../utils/kinds';

import '../styles/kind-badge.css';

// La insignia de tipo de un repositorio: forma, tono y palabra.
//
// Vive acá, en la feature de repositorios, porque el tipo de un repositorio es
// conocimiento de repositorios — y es UN componente porque lo usan dos
// pantallas: el listado y el detalle de una tarea. La misma cosa tiene que
// verse igual en las dos, y dos copias del chip es como dejan de verse igual.
//
// EL COLOR NUNCA ES LA ETIQUETA. La palabra va siempre al lado del glifo, y los
// cinco glifos se distinguen por silueta antes que por tono. El tono sale de
// `--mm-kind-*` en design/tokens.css, con un valor por tema (paleta.md §7).
//
// `label={false}` deja solo la forma, para donde el nombre del tipo ya está
// dicho al lado. El `title` se queda igual: quitar la palabra no puede quitar
// la forma de leerla.

export default function KindBadge({ kind, label = true }) {
    const meta = kindOf(kind);

    return (
        <span
            className={`kind-badge kind-badge--${meta.tone}`}
            title={meta.label}
        >
            <meta.Icon />
            {label && <span className="kind-badge__label">{meta.label}</span>}
        </span>
    );
}
